var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"elfsight-app-582645f2-10aa-4a5f-85af-e25db2ef3cec",attrs:{"data-elfsight-app-lazy":""}})}
var staticRenderFns = []

export { render, staticRenderFns }